export enum AccountableType {
  SWOTeam = 'SWO Team',
  Customer = 'Customer',
}
